const en = {
  app: {
    name: 'Reco'
  },
  common: {
    all: 'All',
    allDepartments: 'All departments',
    anonymous: 'Anonymous',
    cancel: 'Cancel',
    confirm: 'Confirm',
    creditLabel: 'Credit:',
    delete: 'Delete',
    edit: 'Edit',
    end: 'The end',
    error: 'Something went wrong!',
    errorFormal: 'Something went wrong',
    errorPlain: 'Something went wrong',
    errorOccurred: 'An error occurred',
    exit: 'Log out',
    more: 'Load more',
    myDepartment: 'My department',
    next: 'Next',
    other: 'Other',
    previous: 'Previous',
    scoreLabel: 'Score:',
    skip: 'Skip',
    statusLabel: 'Status:',
    submit: 'Submit',
    today: 'Today',
    tomorrow: 'Tomorrow',
    user: 'User'
  },
  nav: {
    announcements: 'Announcements',
    back: 'Back to previous page',
    conversations: 'Conversations',
    giveKudos: 'Give a colleague a Reco!',
    help: 'Help',
    home: 'Home',
    moodTracker: 'Mood tracker',
    notifications: 'Notifications',
    occasions: 'Occasions',
    rewards: 'Rewards',
    search: 'Search',
    surveys: 'Signals'
  },
  settings: {
    title: 'Settings',
    notifications: 'Notification settings',
    changePassword: 'Change password',
    privacy: 'Terms and privacy policy',
    language: 'Language',
    notifyKudos: 'Notify me when I get a new Reco!',
    notifyAnnouncement: 'Notify me about new announcements!',
    notifyConversation: 'Notify me when someone asks me for a conversation!',
    notifyMoodReminder: 'Daily mood check-in!'
  },
  changePassword: {
    success: 'Your password was changed successfully',
    mismatch: "This doesn't match the new password",
    old: 'Current password',
    new: 'New password',
    repeat: 'Repeat password',
    invalidChars:
      'Password may only contain English letters, digits and allowed symbols'
  },
  auth: {
    loginSuccess: 'You are logged in!',
    username: 'Username',
    password: 'Password',
    login: 'Log in',
    forgotPassword: 'Forgot password',
    registerWelcome: 'Welcome to Reco sign-up!',
    passwordMismatch: "Password confirmation doesn't match the password",
    enterNewPassword: 'Enter your new password',
    confirmPassword: 'Confirm password',
    newPassword: 'New password',
    registerPassword: 'Password',
    registerConfirmPassword: 'Confirm password',
    enterPhone: 'Please enter your mobile number',
    phone: 'Mobile number',
    confirmPhone: 'Confirm mobile number',
    enterCode: 'Enter the 5-digit code sent by SMS to this number',
    resendIn: 'Resend code in {time}',
    resendCode: 'Resend code',
    changePhone: 'Change mobile number',
    registered: 'You signed up successfully :)',
    enterRegisterInfo: 'Enter your details to sign up',
    firstName: 'First name',
    lastName: 'Last name',
    register: 'Sign up'
  },
  notifications: {
    title: 'Notifications',
    allSeenToast: 'All marked as seen!',
    tabNotifications: 'Notifications',
    tabTodos: 'To-dos',
    undone: 'Not done',
    done: 'Done',
    markAllSeen: 'Seen all!',
    empty: 'No notifications yet',
    emptyTodos: 'No to-dos yet'
  },
  home: {
    title: 'Dashboard',
    news: "What's new?",
    noAnnouncements: 'No announcements yet',
    orgMoodAverage: 'Organization mood average',
    outOfFive: '{value} out of 5',
    firstMood: 'Be the first to share how you feel...',
    allKudos: 'All Recos',
    leaderboard: 'Top',
    allCards: 'All Recards',
    generalValues: 'General values',
    organizationValues: 'Organization values',
    noKudos: 'No one has given a Reco yet',
    notificationAccept: 'Sure!',
    notificationReject: 'Not now'
  },
  giveKudos: {
    title: 'Reco!',
    success: 'Your Reco was sent!',
    selected: 'Done',
    groupCost:
      'Giving {point} points to {count} colleagues deducts {total} points ({point}×{count}) from your credit.',
    groupShortage:
      'To give {point} points to {count} colleagues, you need {missing} more points.',
    whoQuestion: 'Who do you want to give a Reco to?',
    selectColleague: 'Select a colleague',
    whichColleague: 'Which colleague is this Reco for?',
    forWhat: 'What for?',
    howMany: 'How many points?',
    maxCoin: 'The maximum score for this Recard is {max}.',
    whichCard: 'Which Recard?',
    send: 'Send it',
    examples: {
      kudos: [
        "You can thank your colleague like this:\nMohammad, thanks for following up on the team's work with so much dedication on top of everything else. It really motivates us.",
        "You can thank your colleague like this:\nMaryam, thank you for all the coordination and for pushing things forward faster. So glad you're on my team!",
        "Praise a colleague's strength:\nAli, you're so well-spoken, energetic and motivated. Thanks for that spirit!",
        'Thank someone who helped you:\nZahra, thank you so much for helping me prepare the course files.',
        'Thank someone who helped you:\nMahsa! Your sense of responsibility and how much you care about helping others solve their problems means a lot to me.',
        "Thank someone you've learned from:\nMehdi! Thanks for always being so cheerful and positive, and for sharing what you know so generously :)",
        'Thank a colleague whose presence alone gives you energy:\nSara, the positive energy you give everyone is wonderful.\nHappy to be your colleague😘😘'
      ],
      anniversary: [
        "You can congratulate your colleague on their work anniversary like this:\nDear Mohammad, happy work anniversary! I'm glad we have such a thoughtful and capable colleague like you...",
        "You can congratulate your colleague on their work anniversary like this:\nNarges, so happy we've had another year working with you. Happy work anniversary!"
      ],
      birthday: [
        'You can wish your colleague a happy birthday like this:\nHappy birthday, dear Zahra! Wishing you good health and lots of smiles, always.',
        "You can wish your colleague a happy birthday like this:\nAli, my kind and hard-working colleague, happy birthday! Wishing you all the best.\nHere's to many more!"
      ]
    }
  },
  mood: {
    examplePrefix: 'For example:\n',
    examples: {
      neutral: [
        "I finished today's tasks on time, feels great",
        'Workload has been heavy these past few days and I am tired',
        "Today's meeting with my manager went really well.",
        "I feel like my work at the company isn't being noticed 😔",
        "A week after joining, I'm really happy here. Good environment, great team 😃",
        "I'm happy to have good colleagues",
        "Lately I feel my manager isn't guiding me well",
        'I caught a cold yesterday and had to stay home today',
        'I finally beat COVID. After a week I can go back to the office',
        "The office internet has been slow for days. It's really frustrating.",
        'Something I spent a month on finally paid off. Feels really good'
      ],
      bad: [
        "It's like my brain is switched off, I don't know what I feel",
        "There's nothing I can do, I'm just watching",
        'Every sound feels like a possible danger',
        'Everything is getting on my nerves',
        'I feel really down today, with or without a reason',
        "I miss someone who isn't here anymore",
        "I don't think anything will get better",
        "My mood changes minute by minute, I'm exhausted",
        "My brain just won't work, it's tired",
        "I can't finish anything",
        'I hate everything',
        'I feel like nobody understands me',
        'My mind only creates worst-case scenarios',
        'Nowhere feels safe'
      ],
      good: [
        'Today I just wanted to notice my numbness, not judge it',
        "I'm scared, but I'm still getting my things done",
        "I'm angry, but I don't want my anger to control me",
        "The sadness is there, but I'm learning to live alongside it",
        "Crying is also a way to keep someone's memory alive",
        'Today all I managed was a shower. That counts as a win too',
        "These ups and downs are normal. I'm practicing tolerating them",
        'I closed my eyes for a minute, and even that helped',
        'Today I only managed to move one small task forward',
        "Amid all this hate, there's still a song that calms me",
        'Someone sent me a sticker today and it warmed my heart',
        "I'm practicing seeing just today",
        'I made a little corner for myself that feels safe'
      ]
    },
    submitted: 'Your mood was saved',
    submittedGreeting: 'Your mood was saved!',
    submitError: 'Something went wrong while saving your mood',
    reasonsError: 'Something went wrong while loading mood reasons',
    showNameToHr: 'Show my name to the HR admin.',
    hideNameFromHr: "Don't show my name to the HR admin.",
    todayQuestion: 'How are you feeling today?',
    details: 'View details',
    anonymousHint:
      "Don't worry; no one sees your name unless you tick the box below",
    hello: 'Hiii',
    nowQuestion: 'How are you feeling right now?',
    later: 'Maybe later',
    orgMood: 'Organization mood',
    pageTitle: 'How are you feeling?',
    orgMoodValue: 'Organization mood: {value}',
    yourMoodValue: 'Your mood: {value}',
    userCount: 'People: {value}',
    unreadMessage: 'Unread message',
    messages: 'Messages',
    chatExpired: 'This chat has expired.'
  },
  profile: {
    title: 'Profile',
    rateSubmitted: 'Your rating was saved',
    noSkills: "You haven't added any skills yet",
    noFavorites: "You haven't added any interests yet",
    noWishes: "You haven't added any wishes yet",
    giveKudosTo: 'Give {name} a Reco!',
    department: '{name} department',
    profileScore: 'Profile score:',
    noProfileScore: 'No ratings yet :(',
    rateProfile: "Rate {name}'s profile!",
    aboutMe: 'About me',
    born: 'Born {date}',
    noAbout: "You haven't written anything about yourself yet :(",
    skills: 'Skills',
    favorites: 'Interests',
    wishes: 'Wishes',
    receivedKudos: 'Received Recos',
    givenKudos: 'Given Recos',
    noReceivedMine: "You haven't received a Reco yet :(",
    noReceived: "{name} hasn't received a Reco yet :(",
    noGivenMine: "You haven't given a Reco yet :(",
    noGiven: "{name} hasn't given a Reco yet :("
  },
  editProfile: {
    title: 'Edit profile',
    avatarChanged: 'Your avatar was changed!',
    avatarDeleted: 'Your avatar was removed!',
    saved: 'Your profile was updated!',
    choosePhoto: 'Choose photo',
    personalInfo: 'Personal info',
    about: 'About me',
    birthday: 'Date of birth',
    saveError: 'Something went wrong.',
    showBirthYear: 'Show my birth year',
    emptyWishes: "You haven't added any wishes yet :(",
    emptyFavorites: "You haven't added any interests yet :(",
    emptySkills: "You haven't added any skills yet :(",
    contacts: 'Contact info',
    linkedin: 'LinkedIn',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    skype: 'Skype',
    phone: 'Phone number',
    email: 'Email',
    instagram: 'Instagram',
    save: 'Save',
    zoom: 'Zoom'
  },
  welcome: {
    pageTitle: 'Welcome',
    avatarAdded: 'Your avatar was added!',
    title: 'Welcome to Reco!',
    intro:
      'Reco is an app that helps us build a more enjoyable workplace for ourselves and our colleagues. By using Reco you accept the',
    introEnd: 'of Reco.',
    notificationTitle: 'Notification access',
    notificationText:
      'So Reco can let you know about requests and appreciation from your colleagues, choose "Allow" in the next prompt. If no prompt appears, tap the lock icon at the top of the page and grant access.',
    notificationButton: 'Allow notifications',
    profileTitle: 'Complete your profile!',
    profileText:
      "To get started, let's complete your profile so your colleagues can find you more easily.",
    uploading: 'Uploading',
    changePhoto: 'Change photo',
    uploadPhoto: 'Upload photo',
    doneTitle: 'Congrats!',
    doneText: "You're ready to step into the world of Reco!",
    doneHint:
      'To make the journey more enjoyable, we suggest completing your profile so you can enjoy working alongside your colleagues.',
    goToProfile: 'Go to profile'
  },
  occasions: {
    birthdays: 'Birthdays',
    anniversaries: 'Work anniversaries',
    congratulate: 'Send wishes',
    birthdaysThisMonth: "Colleagues' birthdays this month",
    noBirthdays: 'None of your colleagues has a birthday this month :(',
    todayBirthdays: "Today's birthdays ({count})",
    upcomingBirthdays: 'Upcoming birthdays',
    pastBirthdays: 'Past birthdays',
    anniversariesHeader: 'Work anniversaries',
    anniversariesThisMonth: 'Work anniversaries this month',
    noAnniversaries:
      'None of your colleagues has a work anniversary this month :(',
    todayAnniversaries: "Today's work anniversaries",
    upcomingAnniversaries: 'Upcoming work anniversaries',
    pastAnniversaries: 'Past work anniversaries'
  },
  announcements: {
    title: 'Announcements',
    empty: 'No announcements :(',
    attachment: 'Attached file'
  },
  conversations: {
    title: 'Conversations',
    single: 'Conversation',
    request: 'Request a conversation',
    empty: 'No conversations yet',
    requestSent: 'Your conversation request was sent!',
    uploadFailed: "Files couldn't be uploaded.",
    startWith: 'Start a conversation with ...',
    titleOptional: 'Title (optional)',
    titlePlaceholder: 'e.g. Feedback on our recent collaboration',
    selectColleague: 'Select a colleague',
    message: 'Message',
    messagePlaceholder:
      'Which behaviors should I start?\nWhat should I keep doing?\nWhat should I stop doing?',
    attach: 'Attach file',
    maxFiles: 'You can attach up to {max} files.',
    send: 'Send it!',
    replySent: 'Your reply was sent.',
    replyFailed: "Your reply couldn't be sent.",
    downloadFailed: "The file couldn't be downloaded."
  },
  survey: {
    title: 'Signal',
    listTitle: 'Signals',
    active: 'Active signals',
    finished: 'Finished signals',
    emptyActive: 'No active signals',
    empty: 'No signals',
    deadline: 'Respond by',
    sent: 'Your signal response was sent.',
    answerRequired: 'Please enter your answer.',
    optionRequired: 'Please choose an option.',
    anonymousNotice: 'Your answer to this signal will be sent anonymously.',
    identifiedNotice: 'Your answer to this signal will be sent with your name.',
    view: 'View signal',
    start: 'Start signal',
    sendAnswer: 'Send answer',
    sendAnswers: 'Send answers'
  },
  rewards: {
    pageTitle: 'Rewards',
    shop: 'Shop',
    mine: 'My rewards',
    categories: 'Categories',
    categoriesError: 'Something went wrong while loading categories',
    claimed: 'Congrats, you got your reward!',
    myRewardsError: 'Something went wrong while loading your rewards',
    categoryRewardsError:
      'Something went wrong while loading rewards in this category',
    needMore: 'You need {count} more points',
    unavailable: 'Out of stock :(',
    want: 'I want it!',
    shopEmpty: 'The shop is empty for now',
    categoryEmpty: 'This category is empty for now',
    requestDate: 'Requested on: {date}',
    hideDescription: 'Hide reward details',
    showDescription: 'Show reward details',
    noneYet: "You haven't claimed any rewards yet :(",
    codeCopied: 'Code copied!'
  },
  search: {
    placeholder: 'Which colleague are you looking for?',
    department: 'Department',
    noResult: 'No results found :('
  },
  kudos: {
    title: 'Reco',
    deleted: 'The Reco was deleted!',
    comments: 'Comments',
    likes: 'Likes',
    noComments: 'No comments yet :(',
    noLikes: 'No likes yet :('
  },
  comments: {
    sent: 'Your comment was posted',
    deleted: 'Your comment was deleted',
    edited: 'Your comment was edited',
    empty: 'No comments yet :(',
    placeholder: 'Write a comment',
    reply: 'Reply'
  },
  leaderboard: {
    receiver: 'Receivers',
    sender: 'Givers',
    receivers: 'Top receivers',
    senders: 'Top givers',
    empty: 'No one has given a Reco yet :('
  },
  changeLog: {
    title: "What's new in version {version}",
    gotIt: 'Got it'
  },
  dialogs: {
    notificationAccess: {
      question:
        'Should Reco notify you about requests and appreciation from your colleagues?',
      hint: 'Choose "Allow" in the next prompt. If no prompt appears, tap the lock icon at the top of the page and grant access.'
    },
    rejectConversation: 'Decline their request?'
  },
  enums: {
    rewardOrderStatus: {
      new: 'New',
      confirmed: 'Confirmed',
      sent: 'Sent',
      canceled: 'Canceled'
    },
    conversationStatus: {
      new: 'New',
      accept: 'Accepted',
      reject: 'Ended',
      closed: 'Ended'
    },
    surveyQuestionType: {
      short_answer: 'Short answer',
      long_answer: 'Long answer',
      single_choice: 'Single choice',
      multiple_choice: 'Multiple choice',
      scale: 'Scale',
      nps: 'NPS'
    },
    conversationType: {
      direct: 'Direct',
      group: 'Group',
      channel: 'Channel'
    },
    conversationRole: {
      owner: 'Owner',
      admin: 'Admin',
      member: 'Member'
    },
    mediaStatus: {
      in_progress: 'Preparing',
      ready: 'Ready',
      downloaded: 'Downloaded',
      error: 'Error'
    }
  }
};

export default en;
